import React from 'react';
import classNames from 'classnames';

import { useTranslation } from 'react-i18next';

import { PlaylistItem, videoDetails } from 'packages/common/types/playlist';
import { useTheme } from '../../../../../ThemeContext';
import styles from './CollapsibleText.module.scss';

type Props = {
  text: string;
  className?: string;
  maxHeight?: 'none' | number;
  maxWords?: number;
  showMoreClickHandler?: () => void;
  isHubContent?: boolean;
  item: PlaylistItem | videoDetails;
};

const CollapsibleText: React.FC<Props> = ({ text, item, className, maxHeight = 'none', maxWords = 35, showMoreClickHandler, isHubContent }: Props) => {
  const { t } = useTranslation('common');
  
  const getTruncatedText = (inputText: string, wordLimit: number) => {
    const words = inputText.split(' ');
    const isTrancated = words.length > wordLimit;
    const truncated = words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : inputText;
    return { truncated, isTrancated };
  };
  const { universalStyles, themeConfig } = useTheme();
  const hasText = text == '' || text == undefined || text == null;

  const { truncated, isTrancated } = getTruncatedText(text, maxWords);
  const ismaxWordsExceeds = !hasText ? text.split(' ').length > maxWords : false;
  const isShowMoreButton = (isHubContent && hasText) || (isHubContent && !isTrancated);
  const isShowMoreIsmaxWordsExceeds = isHubContent && isTrancated;

  const allEmpty = ([item.audio_language, item.sub_title, item.cast, item.director, item.producer, item.studio] as (string | undefined | null)[]).every(
    (value) => !value || value.trim() === '',
  );

  return (
    <div className={classNames(styles.collapsibleText, className)}>
      <p className={styles.textContainer} style={universalStyles.videoDetailsDescription}>
        <span>
          {truncated}
          {(!allEmpty || ismaxWordsExceeds) && (!isHubContent || !isShowMoreButton || isShowMoreIsmaxWordsExceeds) && (
            <button type="button" className={styles.toggleText} onClick={showMoreClickHandler} style={{ color: themeConfig.primary }}>
              {t('more')}
            </button>
          )}
        </span>
      </p>
    </div>
  );
};

export default CollapsibleText;
